import capitalize from "capitalize";
import dayjs from "dayjs";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/locales/en.json";
import fr from "@/locales/fr.json";

import "dayjs/locale/fr";

declare global {
	interface String {
		capfirst(): string;
		title(): string;
	}
}

String.prototype.capfirst = function (this: string) {
	return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.title = function (this: string) {
	return capitalize.words(this);
};

export function getI18nLocale(language?: string): string {
	return language?.split("-")[0] || "fr";
}

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			fr: { translation: fr },
		},
		fallbackLng: "fr",
		ns: ["translation"],
		defaultNS: "translation",
		keySeparator: false,
		nsSeparator: false,
		interpolation: {
			escapeValue: false,
		},
		detection: {
			caches: ["localStorage"],
		},
	});

dayjs.locale(getI18nLocale(i18n.resolvedLanguage));
i18n.on("languageChanged", (lng) => {
	dayjs.locale(getI18nLocale(lng));
});

export const t = i18n.t.bind(i18n);
export default i18n;
